export default "__VITE_PUBLIC_ASSET__cb557bbc__"